import {
  ApplicationInitStatus,
  EnvironmentInjector,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';

import { MAINTENANCE_ROUTES } from '../injection-tokens';
import { MaintenanceRoutes } from '../models';
import { MaintenanceLockService } from '../services';

/**
 * Startet die Überwachung der Wartungssperre.
 *
 * Die Sperre hängt bewusst nicht mehr daran, dass irgendwo ein Banner gerendert wird: ein Umbau des Layouts
 * würde sie sonst still abschalten. Aufgelöst wird der Dienst erst nach der App-Initialisierung, denn vorher
 * gibt es noch keine Anmeldung - und damit auch keinen Zustand, den der Server beantworten könnte.
 * @param routes The application routes the maintenance mode has to know.
 * @returns The environment providers of the maintenance feature.
 */
export function provideMaintenanceFeature(routes: MaintenanceRoutes): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MAINTENANCE_ROUTES, useValue: routes },
    provideEnvironmentInitializer(() => {
      const injector = inject(EnvironmentInjector);

      void inject(ApplicationInitStatus).donePromise.then(
        () => injector.get(MaintenanceLockService),
        // Ein gescheiterter Start führt auf die Fehlerseite - dort gibt es nichts zu sperren.
        () => undefined,
      );
    }),
  ]);
}
